import { useCallback, useEffect, useState } from "react";
import { Loader } from "components/ui";
import {
  config as fontAwesomeConfig,
  library as fontAwesomeLibrary,
} from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";
import Login from "components/layout/body/Login";
import Content from "components/layout/body/Content";
import { useAuth } from "hooks/auth";
import { useApi } from "hooks/api";
import { OAuthToken } from "types/qbank/token";
import { useMutation } from "react-query";
import SessionDetailsPrompt from "components/layout/body/SessionDetailsPrompt";
import { Container, CssBaseline, ThemeProvider } from "@mui/material";
import LogoutFooter from "components/layout/footer/LogoutFooter";
import theme from "Theme";
import { StyledEngineProvider } from '@mui/material/styles';

//Only using solid icons for now, these icons take a lot of space in the build
fontAwesomeConfig.autoAddCss = false;
fontAwesomeLibrary.add(fas);

export const APP_VERSION = "0.2.10042";

export default function App() {
  const { auth, setAuth } = useAuth();
  const { refreshToken } = useApi();
  const [isPopUpWindow, setPopUpWindowVisible] = useState(true);
  const { mutate, isLoading } = useMutation(refreshToken, {
    onSuccess: (data: OAuthToken) => {
      setAuth({ isLoggedIn: true, oAuthToken: data });
    },
    onError: (error: any) => {
      setAuth({ isLoggedIn: false });
    },
  });

  const reAuthenticate = useCallback(() => {
    const token = JSON.parse(
      localStorage.getItem("token") || "{}"
    ) as OAuthToken;

    if (!auth.isLoggedIn && token && token.refresh_token) {
      mutate({ refresh_token: token.refresh_token });
    }
  }, [auth.isLoggedIn, mutate]);

  useEffect(() => {
    reAuthenticate();
  }, [reAuthenticate]);

  useEffect(() => {
    //use quesry string to hide pop up button
    const queryParams = new URLSearchParams(window.location.search);
    setPopUpWindowVisible(queryParams.get('popup') === 'true');
  }, []);

  // const selectMedia: SelectMediaFunction = async function (media: Media): Promise<SelectedTemplate[]> {
  //   if (appState && appState.config.onSelect && appState.config.api) {
  //     const defaultTemplate = "@w500h500.jpg",
  //       requested: string[] = appState.config.requestedTemplates?.length
  //         ? appState.config.requestedTemplates
  //         : [defaultTemplate];

  //     let templates: SelectedTemplate[] = [];

  //     for (let i = 0, l = requested.length; i < l; i++) {
  //       let formatted = requested[i],
  //         extension = "jpg";

  //       if (requested[i].indexOf("template:") === 0) {
  //         const imageTemplateId = parseInt(requested[i].split(":")[1]);
  //         let template: ImageTemplate | false =
  //           (appState.deploymentSite &&
  //             appState.deploymentSite.imagetemplates.filter(
  //               (template) => template.id === imageTemplateId
  //             )[0]) ??
  //           (await appState.api.getImageTemplate(imageTemplateId));

  //         if (!template) {
  //           console &&
  //             console.log(
  //               'Could not find image template ID "' + imageTemplateId + '"'
  //             );
  //           formatted = defaultTemplate;
  //         } else {
  //           formatted = interpretTemplateCommands(template);
  //         }
  //       } else if (requested[i][0] !== "@") {
  //         //Assume short form "<width>x<height>" format
  //         formatted = ["@", ...requested[i].split("x"), extension].join("");
  //       }

  //       templates.push({
  //         template: formatted,
  //         url: [
  //           "https:/",
  //           appState.config.api.host,
  //           "api/v1/media",
  //           media.mediaId,
  //           "download?template=" +
  //             formatted +
  //             "&access_token=" +
  //             appState.api.getAccessToken()?.access_token,
  //         ].join("/"),
  //         extension: extension,
  //       });
  //     }

  //     appState.config.onSelect(media, templates);
  //     return templates;
  //   }

  //   console && console.info('No "onSelect" callback specified');
  //   return [];
  // };

  return (
    <div className={`${auth.isLoggedIn ? 'connector' : 'non-login-connector'} ${isPopUpWindow ? 'pop-up' : ''}`}
    >
      <StyledEngineProvider injectFirst>
        <ThemeProvider theme={theme}>
      <CssBaseline />
          <Container sx={{ p: 1, height: "100%" }} disableGutters>
        {isLoading ? <Loader /> : auth.isLoggedIn ? <Content /> : <Login />}
        <SessionDetailsPrompt />
            {!auth.isLoggedIn ? <LogoutFooter /> : null}
      </Container>
        </ThemeProvider>
      </StyledEngineProvider>
    </div>
  );
}
